import { render, staticRenderFns } from "./UserContentOldName.vue?vue&type=template&id=24f3de72&"
import script from "./UserContentOldName.vue?vue&type=script&lang=ts&"
export * from "./UserContentOldName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports